'use memo'

import { NswContractStage, QldContractStage } from '@urbanx/agx-ui-components'
import { AgxButton } from '@urbanx/agx.ui-components2'
import { useSelectedContract } from 'hooks'
import { useState } from 'react'
import ContractTerminateModal from './contract-terminate-modal/ContractTerminateModal'

const TerminateContractAction = () => {
  const { contract } = useSelectedContract()
  const [showConfirmation, setShowConfirmation] = useState(false)
  const isContractTerminated =
    contract?.contractStage === QldContractStage.Terminated ||
    contract?.contractStage === NswContractStage.Terminated

  return (
    <>
      <AgxButton
        id="btnTerminateContract"
        text="Terminate Contract"
        variant="naked"
        danger
        onClick={() => setShowConfirmation(true)}
        disabled={isContractTerminated}
      />
      <ContractTerminateModal
        isOpen={showConfirmation}
        setIsOpen={setShowConfirmation}
      />
    </>
  )
}

export default TerminateContractAction
